export enum LoaderActionTypes {
    SHOW_LOADER = "SHOW_LOADER",
    HIDE_LOADER = "HIDE_LOADER",
    SHOW_SPECIFIC_LOADER = "SHOW_SPECIFIC_LOADER",
    HIDE_SPECIFIC_LOADER = "HIDE_SPECIFIC_LOADER",
}